import { FaSearch, FaPencilRuler, FaHammer, FaCheckCircle, FaPaintBrush, FaThumbsUp } from 'react-icons/fa';
import { images } from '../constants';

const process = [
  {
    id: 1,
    image: images.step1,
    icon: <FaSearch />,
    title: 'Assessment',
    content: 'Thorough evaluation of your woodworking needs and requirements to provide tailored solutions.',
  },
  {
    id: 2,
    image: images.step2,
    icon: <FaPencilRuler />,
    title: 'Design',
    content: "Professional design and customization of woodworking projects to match your space's aesthetics and requirements.",
  },
  {
    id: 3,
    image: images.step3,
    icon: <FaHammer />,
    title: 'Craftsmanship',
    content: 'Expert craftsmanship in woodworking with precision and attention to detail to ensure optimal results.',
  },
  {
    id: 4,
    image: images.step4,
    icon: <FaCheckCircle />,
    title: 'Quality Check',
    content: 'Rigorous quality checks and inspections to verify the functionality and durability of crafted woodwork.',
  },
  {
    id: 5,
    image: images.step5,
    icon: <FaPaintBrush />,
    title: 'Finishing',
    content: 'Professional finishing services to enhance the appearance and longevity of your woodworking projects.',
  },
  {
    id: 6,
    image: images.step6,
    icon: <FaThumbsUp />,
    title: 'Client Approval',
    content: 'Ensuring client satisfaction by delivering woodworking projects that meet or exceed expectations.',
  },
];

export default process;